<template>
  <div>
    <v-dialog v-model="dialogCroper" v-if="imgSrc" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center"> Image Cropper </v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <div>
            <vue-cropper ref="cropper" :src="imgSrc" alt="Source Image">
            </vue-cropper>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn text @click="cancel()"> Cerrar </v-btn>
          <v-btn outlined text @click="cropImage()"> Hecho </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "ImageCropperDialog",
  props: ["dialogCroper", "imgSrc"],
  components: { VueCropper },
  methods: {
    cropImage() {
      let cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let fileBlob = this.dataURItoBlob(cropImg);
      this.$emit("setCropedImage", fileBlob);
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(",")[1]);
      // separate out the mime component
      const mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      // write the bytes of the string to an ArrayBuffer
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      //New Code
      return new Blob([ab], { type: mimeString });
    },
    cancel() {
      this.$emit("closeImageCroper");
    }
  }
};
</script>

<style scoped lang="scss"></style>
